module.exports = __webpack_public_path__ + "img/certificate_icon.8e918ef5.svg";